import Day from './day';

export default Day;
